"use client"

import { useState } from "react"
import AbacusDisplay from "./AbacusDisplay"

const AbacusArithmetic = ({ onScore }) => {
  const [currentProblem, setCurrentProblem] = useState(0)
  const [selectedAnswer, setSelectedAnswer] = useState(null)
  const [showResult, setShowResult] = useState(false)

  const problems = [
    { initial: 3, operation: "+1", result: 4, operationText: "3 + 1 = ?" },
    { initial: 4, operation: "-1", result: 3, operationText: "4 - 1 = ?" },
    { initial: 2, operation: "+2", result: 4, operationText: "2 + 2 = ?" },
    { initial: 5, operation: "-2", result: 3, operationText: "5 - 2 = ?" },
    { initial: 1, operation: "+3", result: 4, operationText: "1 + 3 = ?" },
    { initial: 6, operation: "-3", result: 3, operationText: "6 - 3 = ?" },
  ]

  const current = problems[currentProblem]

  const checkAnswer = () => {
    const correct = selectedAnswer === current.result
    if (correct) {
      onScore(20)
      setTimeout(() => {
        setCurrentProblem((prev) => (prev + 1) % problems.length)
        setSelectedAnswer(null)
        setShowResult(false)
      }, 2000)
    }
    setShowResult(true)
  }

  return (
    <div className="lesson-card card-blue">
      <h2 className="lesson-title" style={{ color: "#1e40af" }}>
        Абакус: Сложение и Вычитание 🧮
      </h2>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: "24px",
          marginBottom: "24px",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <h3 style={{ fontSize: "1.125rem", fontWeight: "bold", marginBottom: "16px" }}>Начальное значение</h3>
          <AbacusDisplay value={current.initial} />
        </div>

        <div style={{ textAlign: "center" }}>
          <h3 style={{ fontSize: "1.125rem", fontWeight: "bold", marginBottom: "16px" }}>Операция</h3>
          <div
            style={{
              fontSize: "2.5rem",
              fontWeight: "bold",
              color: "#2563eb",
              backgroundColor: "white",
              padding: "24px",
              borderRadius: "8px",
              border: "2px solid #e5e7eb",
            }}
          >
            {current.operation}
          </div>
          <p style={{ fontSize: "1.25rem", marginTop: "16px" }}>{current.operationText}</p>
        </div>

        <div style={{ textAlign: "center" }}>
          <h3 style={{ fontSize: "1.125rem", fontWeight: "bold", marginBottom: "16px" }}>Результат</h3>
          <div
            style={{
              fontSize: "3.75rem",
              fontWeight: "bold",
              color: "#16a34a",
              backgroundColor: "white",
              padding: "24px",
              borderRadius: "8px",
              border: "2px solid #e5e7eb",
            }}
          >
            ?
          </div>
        </div>
      </div>

      <div style={{ textAlign: "center", marginBottom: "24px" }}>
        <p style={{ fontSize: "1.25rem", marginBottom: "16px" }}>Выберите правильный ответ:</p>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "16px",
            maxWidth: "400px",
            margin: "0 auto",
          }}
        >
          {[1, 2, 3, 4, 5, 6, 7, 8].map((num) => (
            <button
              key={num}
              onClick={() => setSelectedAnswer(num)}
              style={{
                fontSize: "1.25rem",
                padding: "16px",
                borderRadius: "8px",
                border: "2px solid",
                backgroundColor: selectedAnswer === num ? "#22c55e" : "white",
                color: selectedAnswer === num ? "white" : "#374151",
                borderColor: selectedAnswer === num ? "#16a34a" : "#e5e7eb",
                cursor: "pointer",
              }}
            >
              {num}
            </button>
          ))}
        </div>
      </div>

      {showResult && (
        <div
          style={{
            textAlign: "center",
            fontSize: "1.25rem",
            marginBottom: "16px",
            color: selectedAnswer === current.result ? "#16a34a" : "#dc2626",
          }}
        >
          {selectedAnswer === current.result ? "🎉 Правильно!" : "❌ Попробуй еще раз!"}
          {selectedAnswer === current.result && (
            <div style={{ marginTop: "16px" }}>
              <AbacusDisplay value={current.result} showOperation={true} operation={`Результат: ${current.result}`} />
            </div>
          )}
        </div>
      )}

      <div style={{ textAlign: "center" }}>
        <button
          onClick={checkAnswer}
          disabled={selectedAnswer === null}
          className="nav-button primary"
          style={{ opacity: selectedAnswer === null ? 0.5 : 1 }}
        >
          Проверить! ✨
        </button>
      </div>
    </div>
  )
}

export default AbacusArithmetic
